import React from 'react';
import PropTypes from 'prop-types';
export default class TopIf extends React.Component {

    render() {
        if (this.props.isTrue) {
            return this.props.children;
        } else {
            return false;
        }
    }
}

TopIf.propTypes = {
    isTrue: PropTypes.bool.isRequired
}


// WEBPACK FOOTER //
// ./src/componentsTopsa/if/TopIf.js